module.exports = __webpack_public_path__ + "img/empty-folder-illustration.caff4fcd.svg";